<!-- 新建/编辑房源管理 -->
<template>
  <el-main style="background: #ffffff;">
    <div class="tableList" :style="{padding:0,margin: 0}">
      <div class="tableContent" :style="{padding:'10px 15px'}">
        <div class="cropper-app">
          <div><span>基本信息</span><el-divider></el-divider></div>
          <el-form :model="formValidate" :rules="ruleValidate" ref="formValidate"  label-width="120px">
            <el-form-item label="标题:" prop="title">
              <el-input v-model="formValidate.title" placeholder="请输入标题"></el-input>
            </el-form-item>
            <el-row :style="{margin:'0px!important'}">
              <!--<el-col :span="6" :style="{paddingLeft:'0px!important'}">
                <el-form-item label="城市:" prop="city">
                  <el-select v-model="formValidate.city" placeholder="请选择城市" :style="{width:'100%'}" @change="getHouseApplyNo($event)" disabled>
                    <el-option v-for="item in this.cityList" :key="item.id" :label="item.name" :value="item.name"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>-->
              <el-col :span="12">
                <el-form-item label="房源编号:" prop="no">
                  <el-input v-model="formValidate.no" placeholder="" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="公寓官网链接:" prop="link" v-if="false">
                  <el-input v-model="formValidate.link" placeholder="请输入公寓官网链接"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="公寓位置:" prop="position" v-if="false">
                  <el-input v-model="formValidate.position" placeholder="请输入公寓位置"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12" :style="{paddingRight:'0px!important'}">
                <el-form-item label="楼层数:" prop="floor">
                  <el-input type="number" v-model="formValidate.floor" placeholder="请输入楼层数"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item label="价格:" prop="price" v-if="this.dataList.id != undefined">
              <el-button class="button-new-tag" size="small" @click="addPriceList()">+</el-button>
            </el-form-item>
            <div class="tableContent" style="margin-left: 120px;" v-if="this.dataList.id != undefined">
              <el-table
                row-key="id"
                class="table"
                :key="tableData"
                :data="table.tableData"
                border
                :height="table.tableHeight"
                element-loading-text="拼命加载中,请等待"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(0, 0, 0, 0.1)"
              >
                <el-table-column width="100" prop="id" label="序号" align="center">
                  <template slot-scope="scope">
                    <span>{{ (paging.page-1)*paging.size+scope.$index+1 }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="term" label="租期" align="center">
                  <template slot-scope="scope">
                    <el-input size="small" v-model="scope.row.term" v-show="scope.row.showEdit" placeholder="请输入内容"></el-input>
                    <span v-show="!scope.row.showEdit">{{scope.row.term}}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="price" label="价格" align="center">
                  <template slot-scope="scope">
                    <el-input size="small"type="number" v-model="scope.row.price" v-show="scope.row.showEdit" placeholder="请输入内容" ></el-input>
                    <span v-show="!scope.row.showEdit">{{scope.row.price}}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="start" label="起租日期" align="center">
                  <template slot-scope="scope">
                    <el-date-picker v-model="scope.row.start" v-show="scope.row.showEdit"  type="date" placeholder="请选择起租日期"></el-date-picker>
                    <span v-show="!scope.row.showEdit">{{scope.row.start}}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="finis" label="止租日期" align="center">
                  <template slot-scope="scope">
                    <el-date-picker v-model="scope.row.finis" v-show="scope.row.showEdit"  type="date" placeholder="请选择止租日期"></el-date-picker>
                    <span v-show="!scope.row.showEdit">{{scope.row.finis}}</span>
                  </template>
                </el-table-column>
                <el-table-column label="操作" align="center" width="180" fixed="right">
                  <template slot-scope="scope">
                    <el-button type="text" size="mini" @click="handleOperation('edit',scope.row)" :icon="scope.row.showEdit?'el-icon-check':'el-icon-edit'" :style="{color: $store.state.activeColor}">{{scope.row.showEdit?'保存':'编辑'}}</el-button>
                    <el-popconfirm class="real_pop" title="您确定要复制房源价格信息吗？" @confirm="handleOperation('copy', scope.row)" style="margin-left: 15px" v-if="!scope.row.showEdit">
                      <el-button slot="reference" type="text" size="mini" icon="el-icon-s-claim" :style="{color: $store.state.activeColor}">复制</el-button>
                    </el-popconfirm>
                    <el-popconfirm class="real_pop" title="您确定要删除房源价格信息吗？" @confirm="handleOperation('remove', scope.row)">
                      <el-button class="danger" slot="reference" type="text" size="mini" :icon="scope.row.status ? 'el-icon-circle-check':'el-icon-circle-close'">删除</el-button>
                    </el-popconfirm>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="tablePagination" style="margin:15px 0 25px 120px" v-if="this.dataList.id != undefined">
              <el-pagination
                class="customPagination"
                @size-change="handlePaginationChange"
                @current-change="handlePaginationCurrentChange"
                :current-page="paging.page"
                :page-sizes="[15, 25, 50]"
                :page-size="paging.size"
                layout="total, sizes, prev, pager, next, jumper"
                :total="paging.total"
              >
              </el-pagination>
            </div>
            <!--<el-form-item label="价格:" prop="price">
              <el-tag :key="tag" v-for="tag in formValidate.priceList" closable :disable-transitions="false" @close="tagClose(tag,'price')">{{tag}}</el-tag>
              <span v-if="formValidate.priceVisible">
                <el-input class="input-new-tag" v-model="formValidate.priceValue" size="small"></el-input>
                <span>/周(租期 <el-input class="input-new-tag" v-model="formValidate.priceLeaseValue" ref="priceTagInput" size="small"></el-input> 周)</span>
                <el-button type="text" @click="handleInputConfirm('price')">保存</el-button>
              </span>
              <el-button v-else class="button-new-tag" size="small" @click="showInput('price')">+</el-button>
            </el-form-item>
            <el-form-item label="学校:">
              <el-tag :key="tag" v-for="tag in formValidate.schoolKeyword" :disable-transitions="false" @close="tagClose(tag,'school')">{{ tag }}</el-tag>
              <el-select v-if="formValidate.schoolVisible" v-model="formValidate.schoolValue" placeholder="请选择城市" ref="schoolTagInput" size="small" @keyup.enter.native="handleInputConfirm('school')" @change="handleInputConfirm('school')">
                <el-option v-for="item in schoolList" :disabled="item.disabled" :key="item.id" :label="item.name" :value="item.name"></el-option>
              </el-select>
              <el-button v-else class="button-new-tag" size="small" @click="showInput('school')" disabled>+</el-button>
            </el-form-item>
            <el-form-item label="区域:">
              <el-tag :key="tag" v-for="tag in formValidate.regionKeyword" :disable-transitions="false" @close="tagClose(tag,'region')">{{ tag }}</el-tag>
              <el-select v-if="formValidate.regionVisible" v-model="formValidate.regionValue" placeholder="请选择区域" ref="regionTagInput" size="small" @keyup.enter.native="handleInputConfirm('region')" @change="handleInputConfirm('region')">
                <el-option v-for="item in regionList" :disabled="item.disabled" :key="item.id" :label="item.name" :value="item.name"></el-option>
              </el-select>
              <el-button v-else class="button-new-tag" size="small" @click="showInput('region')" disabled>+</el-button>
            </el-form-item>
            <el-form-item label="地标:">
              <el-tag :key="tag" v-for="tag in formValidate.landmarkKeyword" :disable-transitions="false" @close="tagClose(tag,'landmark')">{{ tag }}</el-tag>
              <el-select v-if="formValidate.landmarkVisible" v-model="formValidate.landmarkValue" placeholder="请选择地标" ref="landmarkTagInput" size="small" @keyup.enter.native="handleInputConfirm('landmark')" @change="handleInputConfirm('landmark')">
                <el-option v-for="item in landmarkList" :disabled="item.disabled" :key="item.id" :label="item.name" :value="item.name"></el-option>
              </el-select>
              <el-button v-else class="button-new-tag" size="small" @click="showInput('landmark')" disabled>+</el-button>
            </el-form-item>
            <el-form-item label="描述:">
              <el-input type="textarea" v-model="formValidate.introduction" placeholder="请输入描述" disabled></el-input>
            </el-form-item>-->
            <el-form-item label="特殊情况备注:">
              <el-input type="textarea" :rows="4" v-model="formValidate.remarks" maxlength="500" show-word-limit placeholder="请输入特殊情况备注"></el-input>
            </el-form-item>
            <el-form-item label="房源地图:">
              <li :style="{marginRight:'10px',whiteSpace:'nowrap',display:'inline-block',padding:'0',position:'relative'}" v-if="formValidate.mapList!= ''">
                <img :style="{width: '225px',height:'150px',marginTop: '3px'}" :src="bindSrc(formValidate.mapList)">
                <i @click="delMap" :style="{position:'absolute',color: $store.state.noticeColor,fontSize: '25px',top:'0',right:'-3px',zIndex:'99',cursor:'pointer'}" class="el-icon-error"></i>
              </li>
              <li :style="{marginRight:'10px',whiteSpace:'nowrap',display:'inline-block',padding:'0',position:'relative'}">
                <el-upload
                  class="avatar-uploader-map"
                  action="https://jsonplaceholder.typicode.com/posts/"
                  :show-file-list="false"
                  :on-success="handleAvatarSuccess"
                  :before-upload="beforeAvatarUpload"
                  :http-request="handleHttpRequestPhoto">
                  <img v-if="formValidate.mainMap" :src="formValidate.mainMap" class="avatar-map" :style="{width:'230px',height:'150px',marginLeft:'10px'}">
                  <div v-else class="avatar-uploader-map-child"><i class="el-icon-plus avatar-uploader-icon"></i><span style="font-size: 14px;">添加图片</span></div>
                </el-upload>
              </li>
            </el-form-item>
            <!--<el-form-item label="房源地图:">
              <div class="list-img-box">
                <li :style="{marginRight:'10px',whiteSpace:'nowrap',display:'inline-block',padding:'0',position:'relative'}" v-if="formValidate.mapList!= ''">
                  <img :style="{width: '225px',height:'150px',marginTop: '3px'}" :src="bindSrc(formValidate.mapList)">
                  <i @click="delMap" :style="{position:'absolute',color: $store.state.noticeColor,fontSize: '25px',top:'0',right:'-3px',zIndex:'99',cursor:'pointer'}" class="el-icon-error"></i>
                </li>
                <li :style="{marginRight:'10px',whiteSpace:'nowrap',display:'inline-block',padding:'0',position:'relative'}">
                  <div :style="{width:'230px',height: '150px',float:'left'}" class="upload-btn" @click="uploadPicture('flagMap')">
                    <i class="el-icon-plus" style="font-size: 30px;"></i><span>添加图片</span>
                  </div>
                </li>
                <img v-show="false" :src="formValidate.mainMap" :style="{width:'230px',height:'150px',marginLeft:'10px'}"  alt="自定义图片">
              </div>
              <input type="hidden" v-model="formValidate.mainMap" placeholder="请添加图片">
            </el-form-item>-->
            <el-form-item label="照片:">
              <div class="list-img-box">
                <draggable group="article" :value="formValidate.photoList" @input="handleListPictureChange($event)">
                  <li :style="{marginRight:'10px',whiteSpace:'nowrap',display:'inline-block',padding:'0',position:'relative'}" v-for="(item,index) in formValidate.photoList" :key="index">
                    <img :style="{width: '225px',height:'150px',marginTop: '3px'}" :src="bindSrc(item)">
                    <i @click="delPhoto(index)" :style="{position:'absolute',color: $store.state.noticeColor,fontSize: '25px',top:'0',right:'-3px',zIndex:'99',cursor:'pointer'}" class="el-icon-error"></i>
                  </li>
                </draggable>
                <img v-show="false" :src="formValidate.mainImage" :style="{width:'230px',height:'150px',marginLeft:'10px'}"  alt="自定义图片">
                <div :style="{width:'230px',height: '150px'}" class="upload-btn" @click="uploadPicture('flagImg')">
                  <i class="el-icon-plus" style="font-size: 30px;"></i><span>添加图片</span>
                </div>
              </div>
              <input type="hidden" v-model="formValidate.mainImage" placeholder="请添加图片">
            </el-form-item>
            <el-form-item label="视频:">
              <div class="list-img-box">
                <draggable group="article" :value="formValidate.videoList" @input="handleListVideoChange($event)">
                  <li :style="{marginRight:'10px',whiteSpace:'nowrap',display:'inline-block',padding:'0',position:'relative'}" v-for="(item,index) in formValidate.videoList" :key="index">
                    <video :style="{width: '225px',height:'150px',marginTop: '3px'}" :src="bindSrc(item)" controls="controls"></video>
                    <i @click="delVideo(index)" :style="{position:'absolute',color: $store.state.noticeColor,fontSize: '25px',top:'0',right:'-3px',zIndex:'99',cursor:'pointer'}" class="el-icon-error"></i>
                  </li>
                </draggable>
                <video v-show="false" :src="formValidate.mainVideo" :style="{width:'230px',height:'150px',marginLeft:'10px'}" controls="controls"></video>
                <div :style="{width:'230px',height: '150px'}" class="upload-btn" @click="uploadVideo()">
                  <i class="el-icon-plus" style="font-size: 30px;"></i><span>添加视频</span>
                </div>
              </div>
              <input type="hidden" v-model="formValidate.mainVideo" placeholder="请添加视频">
            </el-form-item>
            <div><span>房屋信息</span><el-divider></el-divider></div>
            <el-row :style="{margin:'0px!important'}">
              <el-col :span="6" :style="{paddingLeft:'0px!important'}">
                <el-form-item label="户型面积:" prop="measure">
                  <el-input v-model="formValidate.measure" placeholder="请输入户型面积"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="卫浴:" prop="area">
                  <el-select v-model="formValidate.area" placeholder="请选择卫浴" :style="{width:'100%'}">
                    <el-option v-for="item in areaList" :key="item.id" :label="item.name" :value="item.name"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="家具:" prop="furniture">
                  <el-select v-model="formValidate.furniture" placeholder="请选择家具" :style="{width:'100%'}">
                    <el-option v-for="item in furnitureList" :key="item.id" :label="item.name" :value="item.name"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="厨房:" prop="parkingSpace" style="{paddingRight:'0px!important'}">
                  <el-select v-model="formValidate.parkingSpace" placeholder="请选择厨房" :style="{width:'100%'}">
                    <el-option v-for="item in areaparkingSpaceList" :key="item.id" :label="item.name" :value="item.name"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="车位:" prop="parkingSpaceA">
                  <el-input v-model="formValidate.parkingSpaceA" placeholder="请输入车位"></el-input>
                </el-form-item>
              </el-col>
              <div v-if="this.dataList.id != undefined">
                <div v-for="(item,index) in formValidate.mattressList" :key="index">
                  <el-col :span="6" style="position: relative">
                    <el-form-item label="床垫:" prop="info" >
                      <div>{{item.info}}</div>
                    </el-form-item>
                    <div style="position:absolute; top:9px;right:0px;color:rgb(234, 7, 34);cursor: pointer;" @click="delParkingInput(index)"><i class="el-icon-error"></i></div>
                  </el-col>
                </div>
              </div>
              <div v-if="this.dataList.id != undefined">
                <div v-for="(item,index) in table.houseTableData" :key="index">
                  <el-col :span="6" style="position: relative">
                    <el-form-item :label="item.customName + ':'" prop="measure">
                      <div>{{item.content}}</div>
                    </el-form-item>
                    <div style="position:absolute; top:9px;right:0px;color:rgb(234, 7, 34);cursor: pointer;" @click="delHousingInput(index)"><i class="el-icon-error"></i></div>
                  </el-col>
                </div>
              </div>
              <div v-if="this.dataList.id != undefined">
                <el-col :span="6" style="display: flex; flex-direction: row;">
                  <el-button style="margin-top: 4px;" class="button-new-tag" size="small" type="primary" :style="{backgroundColor: $store.state.activeColor,borderColor: $store.state.activeColor, width:'150px'}" @click="addParkingInput">新增床垫</el-button>
                  <el-button style="margin-top: 4px;" class="button-new-tag" size="small" type="primary" :style="{backgroundColor: $store.state.activeColor,borderColor: $store.state.activeColor, width:'150px'}" @click="addHousingInput">新增房屋信息</el-button>
                </el-col>
              </div>
            </el-row>
            <div style="padding-top: 10px"><span>房间设施</span><el-divider></el-divider></div>
            <el-row :style="{margin:'0px!important',border:'1px solid rgb(221, 221, 221)',borderBottom:'0',borderRadius:'5px',textAlign:'center',lineHeight: '40px'}">
              <!--列头 -->
              <el-col :style="{width:'16%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"><b>项目</b></el-col>
              <el-col :style="{width:'8%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"><b>是否提供</b></el-col>
              <el-col :style="{width:'8%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"><b>卖点标签</b></el-col>
              <el-col :style="{width:'2%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"></el-col>
              <el-col :style="{width:'16%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"><b>项目</b></el-col>
              <el-col :style="{width:'8%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"><b>是否提供</b></el-col>
              <el-col :style="{width:'8%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"><b>卖点标签</b></el-col>
              <el-col :style="{width:'2%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"></el-col>
              <el-col :style="{width:'16%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"><b>项目</b></el-col>
              <el-col :style="{width:'8%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"><b>是否提供</b></el-col>
              <el-col :style="{width:'8%',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px'}"><b>卖点标签</b></el-col>
              <!-- 拼接项目 -->
              <template v-for="(item,index) in projectFList" :style="{border:'1px solid rgb(221, 221, 221)'}">
                <el-col :style="{width:'16%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}">{{ item.name }}</el-col>
                <el-col :style="{width:'8%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}">
                  <el-checkbox v-if="item.name != ''" :key="item.name" v-model="item.value" @change="handleChange($event,item.name)"></el-checkbox>
                </el-col>
                <el-col :style="{width:'8%',borderRight:index%3 != 2?'1px solid rgb(221, 221, 221)':'0',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}">
                  <el-checkbox v-if="item.name != ''" :key="item.name" v-model="item.top" @change="handleChange($event,item.name,'top')"></el-checkbox>
                </el-col>
                <el-col v-if="index%3 != 2" :style="{width:'2%',borderRight:'1px solid rgb(221, 221, 221)',borderBottom:'1px solid rgb(221, 221, 221)',height:'40px',borderRadius:'0'}"></el-col>
              </template>
            </el-row>
            <!-- 剪裁组件弹窗 -->
            <el-dialog title="裁切图片" :visible.sync="cropperModel" width="1100px" append-to-body center :close-on-click-modal="false" :before-close="handlePictureClose">
              <cropper-image :Name="cropperName" :cropperType="cropperType" @uploadImgSuccess="handleUploadPictureSuccess" ref="child" @handlePictureClose="handlePictureClose"></cropper-image>
            </el-dialog>
            <!--查看大封面-->
            <el-dialog title="查看大图片" :visible.sync="imgVisible" append-to-body  center>
              <img :src="imgName" v-if="imgVisible" style="width: 100%" alt="查看">
            </el-dialog>
            <!-- 选择视频组件弹窗 -->
            <el-dialog title="选择视频" :visible.sync="videoModel" width="990px" append-to-body center :close-on-click-modal="false" :before-close="handleVideoClose">
              <cropper-video @uploadVideoSuccess="handleUploadVideoSuccess" ref="video" @handleVideoClose="handleVideoClose"></cropper-video>
            </el-dialog>
          </el-form>
        </div>
      </div>
    </div>
    <!-- 房屋信息新增/编辑 -->
    <el-dialog class="dialog" append-to-body width="98%" :title="houseTitle" :visible.sync="houseVisible" v-if="houseVisible" :close-on-click-modal="false" top="1vh" :before-close="beforeHouseClose" :close-on-press-escape="false" :show-close="false">
      <div class="dialog-content" :style="{overflow: 'auto'}">
        <HousingMessageOperation @closeHousingDialog="closeHousingDialog" ref="HousingMessageOperation"  :typeMess="typeMess" :addOrEdit="addOrEdit" :houseIdAOE="houseIdAOE"></HousingMessageOperation>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button  size="medium" type="primary" :style="{backgroundColor: $store.state.activeColor,borderColor: $store.state.activeColor, width:'150px'}" @click="appendHousingContent">保存</el-button>
        <el-button  size="medium" :style="{width:'150px'}" @click="onCancelHousingContent">取消</el-button>
      </div>
    </el-dialog>
  </el-main>
</template>

<script>
  import CropperImage from "../Dialog/CropperImage";
  import CropperVideo from "../Dialog/CropperVideo";
  import { quillEditor } from "vue-quill-editor"; //调用编辑器
  import 'quill/dist/quill.core.css';
  import 'quill/dist/quill.snow.css';
  import 'quill/dist/quill.bubble.css';
  import draggable from 'vuedraggable';
  import HousingMessageOperation from './HousingMessageOperation'
  export default {
    name: 'HousingManagementOperationSchool',
    components: {
      CropperImage,
      CropperVideo,
      quillEditor,
      draggable,
      HousingMessageOperation
    },
    props: ['parentData','dataList','isEdit','apartmentClassify'],
    data () {
      return {
        formInline:{},//查询参数
        formValidate: {
          title: '',//标题
          city: '',//城市
          no: '',//房源编号
          mode: '',//房型
          hot: 0,//是否热门
          modeList:['整租','短租','学生公寓'],//房型列表
          price: '',//价格
          priceList:[],//价格列表
          priceVisible: false,//价格标签输入框是否显示
          priceValue: '',//价格标签输入
          priceLeaseValue: '',//价格标签输入(括号内)
          schoolKeyword:[],//学校标签列表
          schoolVisible: false,//学校标签输入框是否显示
          schoolValue: '',//学校标签输入
          regionKeyword:[],//区域标签列表
          regionVisible: false,//区域标签输入框是否显示
          regionValue: '',//区域标签输入
          landmarkKeyword:[],//地标标签列表
          landmarkVisible: false,//地标标签输入框是否显示
          landmarkValue: '',//地标标签输入
          link: '',//公寓官网链接
          position: '',//公寓位置
          constructionTime: '',//建成时间
          introduction: '',//描述
          remarks: '',//特殊情况备注
          mainImage: '',//添加图片
          mainVideo: '',//添加video
          mainMap: '',//添加地图
          photoList: [],//添加图片列表
          videoList: [],//添加视频列表
          mapList: "",//添加视频列表
          mainImageSrc: '',//回显图片
          mainVideoSrc: '',//回显视频
          mainMapSrc: '',//回显地图
          measure: '',//户型面积
          area: '',//卫浴
          furniture: '',//家具
          floor: '',//楼层
          parkingSpace: '',//车位
          parkingSpaceA: '',//车位
          parking: '',//床垫
          mattressList:[],//床垫列表
          parentId:0,//房源父级
          projectList:[],
          facilityServices:[],//设施服务
          facilityServicesTop:[],//设施服务推荐项
          apartmentClassify:'',//房型
          facilities:'', // 自定义设施
          classification:1,//添加设施分类1.房间设施, 2.公寓楼设施，
          houseVisible:false,//房屋信息弹出框是否显示
        },
        ruleValidate: { //图片非空验证
          title: [
            { required: true, message: '请输入标题', trigger: 'blur'}
          ],
          city: [
            { required: true, message: '请选择城市', trigger: 'change'}
          ],
          link: [
            { required: true, message: '请输入公寓官网链接', trigger: 'blur'}
          ],
          mode: [
            { required: true, message: '请选择房型', trigger: 'change'}
          ],
          mainImage: [
            { required: true, message: '请上传图片', trigger: 'blur'}
          ],
        },
        houseInfoList:[], // 房屋信息列表
        cropperModel:false,//裁切图片参数弹出框
        videoModel:false,//视频参数弹出框
        cropperType:2,// 裁切图片参数类型,2.照片3.地图
        cropperName:"",//裁切图片参数图片名称
        imgName: "",//裁切图片参数查看大图src
        imgVisible: false,//裁切图片参数是否查看大图
        modeData:{},//房型数据
        cityList:[], // 城市列表
        schoolList:[], // 学校列表
        regionList:[], // 区域列表
        landmarkList:[], // 地标列表
        areaList:[{id:1,name:"独立卫浴"},{id:2,name:"公共卫浴"}], // 卫浴
        areaparkingSpaceList:[{id:1,name:"独立厨房"},{id:2,name:"公共厨房"}], // 厨房
        furnitureList:[{id:1,name:"家具齐全"},{id:2,name:"无家具"}], // 家具数
        tableData:false,
        table: { // 表格参数
          tableData:[], // 表格数据
          houseTableData:[], //房屋信息
          tableHeight: null, // 表格高度
        },
        paging: { // 分页参数
          page: 1,// 页码
          size: 15, // 条数
          total: 0, // 总数
        },
        houseVisible:false, // 房屋的添加/编辑
        houseTitle:"", // 弹出框名称
        addOrEdit:1,//新增/编辑
        typeMess:1,//房屋信息
        houseIdAOE:0,//当前房源id
      }
    },
    computed: {
      editor() {
        return this.$refs.myQuillEditor.quill;
      },
      projectFList: function() {
        return this.formValidate.projectList.filter(function (item) {
          return item.type == 1
        })
      }
    },
    methods: {
      // 图片上传
      async handleHttpRequestPhoto(data){
        let imageUrl = data.file;
        //调用axios上传
        let formData = new FormData();
        formData.append('file',imageUrl,'DX.jpg')
        await this.$api.fileUpload(formData).then(res => {
          if (res.data.status == 200) {
            this.formValidate.mainMapSrc = res.data.data[0].path;
            this.formValidate.mapImage = api_url+"/"+res.data.data[0].path;
            this.formValidate.mapList = this.formValidate.mainMapSrc;
          } else {
            this.$message({
              type: 'error',
              message: res.data.message
            });
          }
        });
      },
      // 图片上传
      handleAvatarSuccess(res, file){
        this.imageUrl = URL.createObjectURL(file.raw);
      },
      beforeAvatarUpload(file) {
        const isJPG =  file.type == "image/jpeg" ||
          file.type == "image/png" ||
          file.type == "image/gif"||
          file.type == "image/jpg";
        if (!isJPG) {
          this.$message.error('上传地图图片格式不正确!');
        }
        return isJPG;
      },
      // 保存
      appendHousingContent(){
        this.$refs.HousingMessageOperation.onConfirm();
      },
      // 取消
      onCancelHousingContent(){
        this.$refs.HousingMessageOperation.onCancel();
      },
      // 关闭弹框
      async closeHousingDialog(){
        this.houseVisible = false;
        if(this.typeMess == 1){
          this.table.houseTableData = await this.getHouseInfoNew(this.dataList.id);
        } else if(this.typeMess == 4){
          //获取床垫信息
          this.formValidate.mattressList = await this.getMattressId(this.dataList.id);
        }
      },
      // 关闭之前
      beforeHouseClose(){
        this.$refs.HousingMessageOperation.clearContent();
      },
      // 获取时间
      getTime(time) {
        if (time == undefined || time == null || time == "") {
          return null;
        } else {
          const d = new Date(time);
          const resDate = d.getFullYear() + '-' + this.p((d.getMonth() + 1)) + '-' + this.p(d.getDate());
          return resDate;
        }
      },
      // 时间是否需要补0
      p(s) {
        return s < 10 ? '0' + s : s
      },
      // 新增房屋信息
      addHousingInput(){
        this.formValidate.houseVisible = true;
      },
      //获取房屋信息数据
      getHouseInfoNew(houseId){
        return new Promise((resolve, reject) => {
          this.$api.getCustomHouseByHouseId({houseId:houseId}).then(async res => {
            if (res.data.status == 200) {
              resolve(res.data.data);
            } else {
              resolve(res);
            }
          }).catch(err => {
            reject(err)
          })
        })
      },
      // 获取表格数据
      getList(){
        let parameter = [{"field":"status", "fun":"ne", "value": "0"},{"field":"house_id", "fun":"like", "value": this.dataList.id}];
        this.$api.findPrice({
          page:this.paging.page,
          size:this.paging.size,
          parameter: JSON.stringify(parameter)
        }).then(res => {
          if (res.data.status == 200) {
            this.table.tableData = res.data.data.records;
            for (let i = 0; i < this.table.tableData.length; i++){
              this.table.tableData[i].showEdit = false;
            }
            this.paging.total = Number(res.data.data.total);
          } else {
            this.$message({
              type: 'error',
              message: res.data.message
            });
          }
        });
      },
      // 分页部分改变条数
      handlePaginationChange(val) {
        this.paging.size = val;
        this.paging.page = 1;
        this.getList();
      },
      // 分页部分改变页码
      handlePaginationCurrentChange(val) {
        this.paging.page = val;
        this.getList();
      },
      // 新增价格
      addPriceList(){
        this.table.tableData.push({price:"",start:"",finis:"",houseId:this.dataList.id,term:"",status:1,showEdit: true});
      },
      // 操作列表
      handleOperation(type,row){
        for (let i = 0; i <this.table.tableData.length; i++){
          this.table.tableData[i].start = this.table.tableData[i].start == null ||  this.table.tableData[i].start == ''? "":this.getTime(this.table.tableData[i].start);
          this.table.tableData[i].finis = this.table.tableData[i].finis == null ||  this.table.tableData[i].finis == ''? "":this.getTime(this.table.tableData[i].finis);
        }
        // 编辑/保存
        if (type == "edit") {
          // 保存
          if (row.showEdit){
            this.$api.saveOrUpdatePriceBatch({parameter: JSON.stringify(this.table.tableData)}).then(res => {
              if (res.data.status == 200) {
                this.$message({
                  type: 'success',
                  message: '保存成功！'
                });
                this.getList();
              } else {
                this.$message({
                  type: 'error',
                  message: res.data.message
                });
              }
            });
          } else { // 编辑
            this.tableData = !this.tableData;
            for (let i = 0; i < this.table.tableData.length; i++){
              if (this.table.tableData[i].id == row.id){
                this.$set(this.table.tableData[i],"showEdit",true);
              }
            }
          }
        } else if (type == "copy") { // 复制
          delete row.id
          this.$api.saveOrUpdatePrice({parameter: JSON.stringify(row)}).then(async res => {
            if (res.data.status == 200) {
              this.$message({
                type: 'success',
                message: '复制成功！'
              });
              this.getList();
            } else {
              this.$message({
                type: 'error',
                message: res.data.message
              });
            }
          });
        } else if (type == "remove") {
          this.tableData = !this.tableData;
          for (let i = 0; i < this.table.tableData.length; i++){
            if (this.table.tableData[i].id == row.id){
              this.table.tableData[i].status = 0;
            }
          }
          this.$api.saveOrUpdatePriceBatch({parameter: JSON.stringify(this.table.tableData)}).then(res => {
            if (res.data.status == 200) {
              this.$message({
                type: 'success',
                message: '保存成功！'
              });
              this.getList();
            } else {
              this.$message({
                type: 'error',
                message: res.data.message
              });
            }
          });
        }
      },
      //图片设置
      uploadPicture(name){
        this.cropperName = name;
        if (name == "flagImg"){
          this.cropperType = 2;
        } else {
          this.cropperType = 3;
        }
        this.cropperModel = true;
      },
      //视频设置
      uploadVideo(){
        this.videoModel = true;
      },
      //图片上传成功后
      handleUploadPictureSuccess (data){
        if (this.cropperType == 2){
          this.formValidate.mainImageSrc = data[0].path;
          this.formValidate.mainImage = api_url+"/"+data[0].path;
          this.formValidate.photoList.push(this.formValidate.mainImageSrc);
          this.handlePictureClose();
        } else {
          this.formValidate.mainMapSrc = data[0].path;
          this.formValidate.mapImage = api_url+"/"+data[0].path;
          this.formValidate.mapList = this.formValidate.mainMapSrc;
          this.handlePictureClose();
        }
      },
      // 关闭上传弹出框
      handlePictureClose() {
        this.cropperModel = false;
        this.$refs.child.beClose();
      },
      //视频上传成功后
      handleUploadVideoSuccess (data){
        this.formValidate.mainVideoSrc = data[0].path;
        this.formValidate.mainVideo = api_url+"/"+data[0].path;
        this.formValidate.videoList.push(this.formValidate.mainVideoSrc);
        this.handleVideoClose();
      },
      // 关闭上传弹出框
      handleVideoClose() {
        this.videoModel = false;
        this.$refs.video.beClose();
      },
      // 转码
      escapeStringHTML(str) {
        str = str.replace(/&lt;/g,'<');
        str = str.replace(/&gt;/g,'>');
        return str;
      },
      // 拼接页面图片地址
      bindSrc(url){
        return api_url+"/"+url;
      },
      // 删除房源地图
      delMap(){
        this.formValidate.mapList = "";
      },
      // 删除图片
      delPhoto(index){
        this.formValidate.photoList.splice(index,1);
      },
      // 删除视频
      delVideo(index){
        this.formValidate.videoList.splice(index,1);
      },
      // 删除学校/区域/地标
      tagClose(tag,type) {
        if (type == 'school'){
          this.formValidate.schoolKeyword.splice(this.formValidate.schoolKeyword.indexOf(tag), 1);
          for (let i = 0; i < this.schoolList.length; i++){
            if (this.schoolList[i].name == tag){
              this.schoolList[i].disabled = false;
            }
          }
        } else if (type == 'region'){
          this.formValidate.regionKeyword.splice(this.formValidate.regionKeyword.indexOf(tag), 1);
          for (let i = 0; i < this.regionList.length; i++){
            if (this.regionList[i].name == tag){
              this.regionList[i].disabled = false;
            }
          }
        } else if (type == 'landmark'){
          this.formValidate.landmarkKeyword.splice(this.formValidate.landmarkKeyword.indexOf(tag), 1);
          for (let i = 0; i < this.landmarkList.length; i++){
            if (this.landmarkList[i].name == tag){
              this.landmarkList[i].disabled = false;
            }
          }
        } else if (type == 'price'){
          this.formValidate.priceList.splice(this.formValidate.priceList.indexOf(tag), 1);
        }
      },
      // 显示学校/区域/地标
      showInput(type) {
        if (type == 'school'){
          this.formValidate.schoolVisible = true;
        } else if(type == 'region'){
          this.formValidate.regionVisible = true;
        } else if(type == 'landmark'){
          this.formValidate.landmarkVisible = true;
        } else if(type == 'price'){
          this.formValidate.priceVisible = true;
        }
      },
      // 添加学校/区域/地标
      handleInputConfirm(type) {
        if (type == 'school'){
          let inputValue = this.formValidate.schoolValue;
          if (inputValue) {
            this.formValidate.schoolKeyword.push(inputValue);
          }
          for (let i = 0; i < this.schoolList.length; i++){
            if (this.schoolList[i].name == inputValue){
              this.schoolList[i].disabled = true;
            }
          }
          this.formValidate.schoolVisible = false;
          this.formValidate.schoolValue = '';
        } else if (type == 'region'){
          let inputValue = this.formValidate.regionValue;
          if (inputValue) {
            this.formValidate.regionKeyword.push(inputValue);
          }
          for (let i = 0; i < this.regionList.length; i++){
            if (this.regionList[i].name == inputValue){
              this.regionList[i].disabled = true;
            }
          }
          this.formValidate.regionVisible = false;
          this.formValidate.regionValue = '';
        } else if (type == 'landmark'){
          let inputValue = this.formValidate.landmarkValue;
          if (inputValue) {
            this.formValidate.landmarkKeyword.push(inputValue);
          }
          for (let i = 0; i < this.landmarkList.length; i++){
            if (this.landmarkList[i].name == inputValue){
              this.landmarkList[i].disabled = true;
            }
          }
          this.formValidate.landmarkVisible = false;
          this.formValidate.landmarkValue = '';
        } else if(type == 'price'){
          let inputValue = this.formValidate.priceValue;
          let priceLeaseValue = this.formValidate.priceLeaseValue;
          if (inputValue && priceLeaseValue) {
            this.formValidate.priceList.push(inputValue+'/周(租期'+priceLeaseValue+'周)');
          }
          this.formValidate.priceVisible = false;
          this.formValidate.priceValue = '';
          this.formValidate.priceLeaseValue = '';
        }
      },
      // 申请房源流水号
      async getHouseApplyNo(data) {
        this.formValidate.no = await this.getHouseApplyNoByNo(data);
      },
      // 房源流水号
      getHouseApplyNoByNo(data) {
        return new Promise((resolve)=>{
          this.$api.houseApplyNo({cityName:data,mode:"学生公寓房型",apartmentNo:this.modeData.no}).then(res => {
            if (res.data.status == 200) {
              resolve(res.data.data);
            } else {
              this.$message({
                type: 'error',
                message: res.data.message
              });
            }
          });
        })
      },
      // 提交上传
       onConfirm() {
        this.$refs['formValidate'].validate(async(valid) => {
            if (valid) {
              let params = {},title="新增";
              if (this.isEdit == 1){
                params = {
                  title:this.formValidate.title,
                  apartmentClassify:this.formValidate.apartmentClassify,
                  city:this.formValidate.city,
                  price:this.formValidate.priceList.toString().replace(/,/g, '|'),
                  no: this.formValidate.no,
                  hot: this.formValidate.hot,
                  mode:this.formValidate.mode,
                  photo:this.formValidate.photoList.toString().replace(/,/g, '|'),
                  video:this.formValidate.videoList.toString().replace(/,/g, '|'),
                  mapImage:this.formValidate.mapList,
                  link:this.formValidate.link,
                  constructionTime:this.formValidate.constructionTime,
                  position:this.formValidate.position,
                  floor:this.formValidate.floor,
                  introduction:this.formValidate.introduction,
                  measure:this.formValidate.measure,
                  kitchen:this.formValidate.parkingSpace,
                  bathroom:this.formValidate.area,
                  remarks:this.formValidate.remarks,
                  regionKeyword:this.formValidate.regionKeyword.toString().replace(/,/g, '|'),
                  landmarkKeyword:this.formValidate.landmarkKeyword.toString().replace(/,/g, '|'),
                  facilityServices:this.formValidate.facilityServices.toString().replace(/,/g, '|'),
                  facilityServicesTop:this.formValidate.facilityServicesTop.toString().replace(/,/g, '|'),
                  houseInfo:this.getHouseInfo(),
                  parentId:this.formValidate.parentId,
                  status:1
                }
              } else {
                params = {
                  id:this.dataList.id,
                  apartmentClassify:this.formValidate.apartmentClassify,
                  title:this.formValidate.title,
                  city:this.formValidate.city,
                  price:this.formValidate.priceList.toString().replace(/,/g, '|'),
                  no:this.formValidate.no,
                  hot:this.formValidate.hot,
                  mode:this.formValidate.mode,
                  parentId:this.formValidate.parentId,
                  photo:this.formValidate.photoList.toString().replace(/,/g, '|'),
                  video:this.formValidate.videoList.toString().replace(/,/g, '|'),
                  mapImage:this.formValidate.mapList,
                  link:this.formValidate.link,
                  constructionTime:this.formValidate.constructionTime,
                  position:this.formValidate.position,
                  floor:this.formValidate.floor,
                  introduction:this.formValidate.introduction,
                  measure:this.formValidate.measure,
                  kitchen:this.formValidate.parkingSpace,
                  bathroom:this.formValidate.area,
                  remarks:this.formValidate.remarks,
                  regionKeyword:this.formValidate.regionKeyword.toString().replace(/,/g, '|'),
                  landmarkKeyword:this.formValidate.landmarkKeyword.toString().replace(/,/g, '|'),
                  facilityServices:this.formValidate.facilityServices.toString().replace(/,/g, '|'),
                  facilityServicesTop:this.formValidate.facilityServicesTop.toString().replace(/,/g, '|'),
                  houseInfo:this.getHouseInfo(),
                  status:1
                }
                title = "编辑";
              }
              this.$api.saveOrUpdateHouseTypeOfApartmentHouse({parameter: JSON.stringify(params)}).then(res => {
                if (res.data.status == 200) {
                  let data = res.data.data;
                  this.$message({
                    type: 'success',
                    message: title+'成功！'
                  });
                  this.$emit('closeDialog');
                } else {
                  this.$message({
                    type: 'error',
                    message: res.data.message
                  });
                }
              });
            }
        })
      },
      // 获取床垫id
      getMattressId(id){
        return new Promise((resolve, reject) => {
          let parameter = [{"field":"status", "fun":"ne", "value": "0"},{"field":"house_id", "fun":"eq", "value": id}];
          this.$api.findMattress({page:1, size:this.$store.state.size, parameter: JSON.stringify(parameter)}).then(res => {
            if (res.data.status == 200) {
              resolve(res.data.data.records);
            } else {
              resolve(res);
            }
          }).catch(err => {
            reject(err)
          })
        })
      },
      // 重新赋值
      clearContent(){
        this.formValidate = {
          title: '',//标题
          city: '',//城市
          no: '',//房源编号
          mode: '',//房型
          hot: 0,//是否热门
          modeList:['整租','短租','学生公寓'],//房型列表
          price: '',//价格
          priceList:[],//价格列表
          priceVisible: false,//价格标签输入框是否显示
          priceValue: '',//价格标签输入
          priceLeaseValue: '',//价格标签输入(括号内)
          schoolKeyword:[],//学校标签列表
          schoolVisible: false,//学校标签输入框是否显示
          schoolValue: '',//学校标签输入
          regionKeyword:[],//区域标签列表
          regionVisible: false,//区域标签输入框是否显示
          regionValue: '',//区域标签输入
          landmarkKeyword:[],//地标标签列表
          landmarkVisible: false,//地标标签输入框是否显示
          landmarkValue: '',//地标标签输入
          link: '',//公寓官网链接
          position: '',//公寓位置
          constructionTime: '',//建成时间
          introduction: '',//描述
          remarks: '',//特殊情况备注
          mainImage: '',//添加图片
          mainVideo: '',//添加video
          mainMap: '',//添加地图
          photoList: [],//添加图片列表
          videoList: [],//添加视频列表
          mapList: "",//添加视频列表
          mainImageSrc: '',//回显图片
          mainVideoSrc: '',//回显视频
          mainMapSrc: '',//回显地图
          measure: '',//户型面积
          area: '',//卫浴
          furniture: '',//家具
          floor: '',//楼层
          parkingSpace: '',//车位
          parking: '',//床垫
          mattressList:[],//床垫列表
          parentId:0,//房源父级
          projectList:[],
          facilityServices:[],//设施服务
          facilityServicesTop:[],//设施服务推荐项
          apartmentClassify:'',//房型
          facilities:'', // 自定义设施
          classification:1,//添加设施分类1.房间设施, 2.公寓楼设施，
          houseVisible:false,//房屋信息弹出框是否显示
        };
      },
      // 获取是否选中
      handleChange(event,item,type){
        if (event){
          if (type != undefined){
            this.formValidate.facilityServicesTop.push(item);
          } else {
            this.formValidate.facilityServices.push(item);
          }
        } else {
          if (type != undefined){
            this.formValidate.facilityServicesTop = this.formValidate.facilityServicesTop.filter(t => t !== item);
          } else {
            this.formValidate.facilityServices = this.formValidate.facilityServices.filter(t => t !== item);
          }
        }
      },
      // 获取房屋信息
      getHouseInfo(){
        let houseInfo = '';
        houseInfo += (this.formValidate.measure == undefined ? '' : this.formValidate.measure)+'|';
        houseInfo += (this.formValidate.area == undefined ? '' : this.formValidate.area)+'|';
        houseInfo += (this.formValidate.furniture == undefined ? '' : this.formValidate.furniture)+'|';
        houseInfo += (this.formValidate.parkingSpace == undefined ? '' : this.formValidate.parkingSpace)+'|';
        houseInfo += (this.formValidate.parkingSpaceA == undefined ? '' : this.formValidate.parkingSpaceA)+'|';
        // if (houseInfo.substr(houseInfo.length-1,1) == "|"){
        //   houseInfo = houseInfo.slice(0,-1);
        // }
        return houseInfo;
      },
      //返回上一页
      onCancel(){
        this.$emit('closeDialog');
      },
      // 获取城市数据
      getCityList(){
        return new Promise((resolve, reject) => {
          let parameter = [{"field":"status", "fun":"ne", "value": "0"}];
          this.$api.findCity({page:1, size:this.$store.state.size, parameter: JSON.stringify(parameter)}).then(res => {
            if (res.data.status == 200) {
              resolve(res.data.data.records);
            } else {
              resolve(res);
            }
          }).catch(err => {
            reject(err)
          })
        })
      },
      // 获取学校数据
      getSchoolList(){
        return new Promise((resolve, reject) => {
          let parameter = [{"field":"status", "fun":"ne", "value": "0"}];
          this.$api.findSchool({page:1, size:this.$store.state.size, parameter: JSON.stringify(parameter)}).then(res => {
            if (res.data.status == 200) {
              for (let i = 0; i < res.data.data.records.length; i++){
                res.data.data.records[i].disabled = false;
              }
              resolve(res.data.data.records);
            } else {
              resolve(res);
            }
          }).catch(err => {
            reject(err)
          })
        })
      },
      // 获取区域数据
      getRegionList(){
        return new Promise((resolve, reject) => {
          let parameter = [{"field":"status", "fun":"ne", "value": "0"}];
          this.$api.findRegion({page:1, size:this.$store.state.size, parameter: JSON.stringify(parameter)}).then(res => {
            if (res.data.status == 200) {
              for (let i = 0; i < res.data.data.records.length; i++){
                res.data.data.records[i].disabled = false;
              }
              resolve(res.data.data.records);
            } else {
              resolve(res);
            }
          }).catch(err => {
            reject(err)
          })
        })
      },
      // 获取地标数据
      getLandmarkList(){
        return new Promise((resolve, reject) => {
          let parameter = [{"field":"status", "fun":"ne", "value": "0"}];
          this.$api.findLandmark({page:1, size:this.$store.state.size, parameter: JSON.stringify(parameter)}).then(res => {
            if (res.data.status == 200) {
              for (let i = 0; i < res.data.data.records.length; i++){
                res.data.data.records[i].disabled = false;
              }
              resolve(res.data.data.records);
            } else {
              resolve(res);
            }
          }).catch(err => {
            reject(err)
          })
        })
      },
      // 获取服务设施数据
      getFacilitiesList(){
        return new Promise((resolve, reject) => {
          let parameter = [{"field":"status", "fun":"ne", "value": "0"}];
          this.$api.findFacilities({page:1, size:this.$store.state.size, parameter: JSON.stringify(parameter)}).then(res => {
            if (res.data.status == 200) {
              let projectList = res.data.data.records;
              for (let i = 0; i < projectList.length; i++){
                projectList[i].value = false;
                projectList[i].top = false;
              }
              resolve(projectList);
            } else {
              resolve(res);
            }
          }).catch(err => {
            reject(err)
          })
        })
      },
      // 新建设施服务数据
      addFacilities(){
        if (this.formValidate.facilities == ""){
          this.$message({
            type: 'error',
            message: '请输入自定义设施名称！'
          });
          return;
        }
        let params = {
          name:this.formValidate.facilities,
          type:this.formValidate.classification,
          status:1
        }
        this.$api.saveOrUpdateFacilities({parameter: JSON.stringify(params)}).then(async res => {
          if (res.data.status == 200) {
            this.$message({
              type: 'success',
              message: '新增成功！'
            });
            // 获取服务设施数据
            this.formValidate.projectList = await this.getFacilitiesList();
            if(this.dataList.id == this.modeData.id){
              let getFacilityServices = this.formValidate.facilityServices;
              let getFacilityServicesTop = this.formValidate.facilityServicesTop;
              for (let i = 0; i < this.formValidate.projectList.length; i++){
                for (let j = 0; j < getFacilityServices.length; j++){
                  if (this.formValidate.projectList[i].name == getFacilityServices[j]){
                    this.formValidate.projectList[i].value = true;
                  }
                }
                for (let m = 0; m < getFacilityServicesTop.length; m++){
                  if (this.formValidate.projectList[i].name == getFacilityServicesTop[m]){
                    this.formValidate.projectList[i].top = true;
                  }
                }
              }
            } else {
              this.formValidate.facilityServices = this.dataList.facilityServices != '' ? this.dataList.facilityServices.split("|"):[];
              this.formValidate.facilityServicesTop = this.dataList.facilityServicesTop !=''? this.dataList.facilityServicesTop.split("|"):[];
              let getFacilityServices = this.dataList.facilityServices != '' ? this.dataList.facilityServices.split("|"):[];
              let getFacilityServicesTop = this.dataList.facilityServicesTop != ''?this.dataList.facilityServicesTop.split("|"):[];
              for (let i = 0; i < this.formValidate.projectList.length; i++){
                for (let j = 0; j < getFacilityServices.length; j++){
                  if (this.formValidate.projectList[i].name == getFacilityServices[j]){
                    this.formValidate.projectList[i].value = true;
                  }
                }
                for (let m = 0; m < getFacilityServicesTop.length; m++){
                  if (this.formValidate.projectList[i].name == getFacilityServicesTop[m]){
                    this.formValidate.projectList[i].top = true;
                  }
                }
              }
              if (this.isEdit == 1){
                this.formValidate.facilityServices = [];
                this.formValidate.facilityServicesTop = [];
              }
            }
            let that = this;
            that.$nextTick(() => {
              that.formValidate.facilityServices.push(that.formValidate.facilities);
              that.formValidate.projectList[that.formValidate.projectList.length - 1].value = true;
              that.formValidate.projectList[that.formValidate.projectList.length - 1].top = false;
              // 清空输入数据
              this.formValidate.facilities = "";
            });
          } else {
            this.$message({
              type: 'error',
              message: res.data.message
            });
          }
        });
      },
      // 新增床垫信息
      addParkingInput(){
        this.typeMess = 4;
        this.addOrEdit = 1;
        this.houseIdAOE = this.dataList.id;
        this.houseVisible = true;
        this.houseTitle = "新增床垫信息";
        let that = this;
        that.$nextTick(() => {
          $(".dialog-content").height(window.innerHeight - 150);
        })
      },
      // 删除床垫信息
      delParkingInput(index){
        this.formValidate.mattressList[index].status = 0;
        this.$api.saveOrUpdateMattressBatch({ parameter: JSON.stringify(this.formValidate.mattressList)}).then(async res => {
          if (res.data.status == 200) {
            //获取床垫信息
            this.formValidate.mattressList = await this.getMattressId(this.dataList.id);
          }
        })
      },
      // 新增房屋信息
      addHousingInput(){
        this.typeMess = 1;
        this.addOrEdit = 1;
        this.houseIdAOE = this.dataList.id;
        this.houseVisible = true;
        this.houseTitle = "新增房屋信息";
        let that = this;
        that.$nextTick(() => {
          $(".dialog-content").height(window.innerHeight - 150);
        })
      },
      // 删除房屋信息
      delHousingInput(index){
        this.table.houseTableData[index].status = 0;
        this.$api.saveOrUpdateCustomHouseBatch({ parameter: JSON.stringify(this.table.houseTableData)}).then(async res => {
          if (res.data.status == 200) {
            //获取房屋信息
            this.table.houseTableData = await this.getHouseInfoNew(this.dataList.id);
          }
        })
      },
      // 更新照片位置
      handleListPictureChange(event){
        this.formValidate.photoList = event;
      },
      // 更新视频位置
      handleListVideoChange(event){
        this.formValidate.videoList = event;
      },
      // 获取房屋信息数据
      getHouseInfoList(){
        return new Promise((resolve, reject) => {
          let parameter = [{"field":"status", "fun":"ne", "value": "0"}];
          this.$api.findCustom({page:1, size:this.$store.state.size, parameter: JSON.stringify(parameter)}).then(res => {
            if (res.data.status == 200) {
              resolve(res.data.data.records);
            } else {
              resolve(res);
            }
          }).catch(err => {
            reject(err)
          })
        })
      },
    },
   async mounted(){
     this.modeData = this.parentData;
     try {
       // 获取城市列表
       this.cityList = await this.getCityList();
       // 获取学校列表
       this.schoolList = await this.getSchoolList();
       // 获取区域列表
       this.regionList = await this.getRegionList();
       // 获取地标列表
       this.landmarkList = await this.getLandmarkList();
       // 获取服务设施数据
       this.formValidate.projectList = await this.getFacilitiesList();
       // 获取房屋信息数据
       this.houseInfoList = await this.getHouseInfoList();
     } catch (err) {
       console.log(err)
     }
      if (this.dataList.id != undefined){
        // 获取房屋信息
        this.formValidate.mattressList = await this.getMattressId(this.dataList.id);
        //获取床垫信息
        this.formValidate.mattressList = await this.getMattressId(this.dataList.id);
        this.table.houseTableData = await this.getHouseInfoNew(this.dataList.id);
        // 获取表格价格数据
        this.getList();
        this.formValidate.title = this.dataList.title;
        this.formValidate.apartmentClassify = this.apartmentClassify;
        this.formValidate.city = this.dataList.city;
        this.formValidate.priceList = this.dataList.price != '' ? this.dataList.price.split("|"):[];
        this.formValidate.mode = this.dataList.mode;
        this.formValidate.no = this.dataList.no;
        this.formValidate.hot = this.dataList.hot;
        this.formValidate.link = this.dataList.link;
        this.formValidate.constructionTime = this.dataList.constructionTime;
        this.formValidate.position = this.dataList.position;
        this.formValidate.floor = this.dataList.floor;
        this.formValidate.introduction = this.dataList.introduction;
        this.formValidate.measure = this.dataList.measure;
        this.formValidate.parkingSpace = this.dataList.parkingSpace;
        this.formValidate.area = this.dataList.bathroom;
        this.formValidate.remarks = this.dataList.remarks;
        this.formValidate.parentId = this.dataList.parentId;
        this.formValidate.photoList = this.dataList.photo != '' && this.dataList.photo != null?this.dataList.photo.split("|"):[];
        this.formValidate.videoList = this.dataList.video != '' && this.dataList.video != null?this.dataList.video.split("|"):[];
        this.formValidate.mapList = this.dataList.mapImage != '' && this.dataList.mapImage != null?this.dataList.mapImage:"";
        this.formValidate.regionKeyword = this.dataList.regionKeyword != ''?this.dataList.regionKeyword.split("|"):[];
        if (this.dataList.regionKeyword != ''){
          let region =  this.dataList.regionKeyword.split("|");
          for (let i = 0; i < this.regionList.length; i++){
            for (let j = 0; j < region.length; j++){
              if (this.regionList[i].name == region[j]){
                this.regionList[i].disabled = true;
              }
            }
          }
        }
        this.formValidate.landmarkKeyword = this.dataList.landmarkKeyword != ''?this.dataList.landmarkKeyword.split("|"):[];
        if (this.dataList.landmarkKeyword != ''){
          let landmark =  this.dataList.landmarkKeyword.split("|");
          for (let i = 0; i < this.landmarkList.length; i++){
            for (let j = 0; j < landmark.length; j++){
              if (this.landmarkList[i].name == landmark[j]){
                this.landmarkList[i].disabled = true;
              }
            }
          }
        }
        let houseInfo = this.dataList.houseInfo.split("|");
        this.formValidate.measure = houseInfo[0];
        this.formValidate.area = houseInfo[1];
        this.formValidate.furniture = houseInfo[2];
        this.formValidate.parkingSpace = houseInfo[3];
        this.formValidate.parkingSpaceA = houseInfo[4];
        this.formValidate.facilityServices = this.dataList.facilityServices != '' ? this.dataList.facilityServices.split("|"):[];
        this.formValidate.facilityServicesTop = this.dataList.facilityServicesTop !=''? this.dataList.facilityServicesTop.split("|"):[];
        let getFacilityServices = this.dataList.facilityServices != '' ? this.dataList.facilityServices.split("|"):[];
        let getFacilityServicesTop = this.dataList.facilityServicesTop != ''?this.dataList.facilityServicesTop.split("|"):[];
        for (let i = 0; i < this.formValidate.projectList.length; i++){
          for (let j = 0; j < getFacilityServices.length; j++){
            if (this.formValidate.projectList[i].name == getFacilityServices[j]){
              this.formValidate.projectList[i].value = true;
            }
          }
          for (let m = 0; m < getFacilityServicesTop.length; m++){
            if (this.formValidate.projectList[i].name == getFacilityServicesTop[m]){
              this.formValidate.projectList[i].top = true;
            }
          }
        }
      } else{
        this.formValidate.apartmentClassify = this.apartmentClassify;
        this.formValidate.city = this.modeData.city;
        this.formValidate.priceList = this.modeData.price != '' ? this.modeData.price.split("|"):[];
        this.formValidate.mode = this.modeData.mode;
        this.formValidate.no = this.modeData.no;
        this.formValidate.hot = this.modeData.hot;
        this.formValidate.link = this.modeData.link;
        this.formValidate.constructionTime = this.modeData.constructionTime;
        this.formValidate.position = this.modeData.position;
        this.formValidate.floor = this.modeData.floor;
        this.formValidate.introduction = this.modeData.introduction;
        this.formValidate.measure = this.modeData.measure;
        this.formValidate.parkingSpace = this.modeData.parkingSpace;
        this.formValidate.area = this.modeData.bathroom;
        this.formValidate.remarks = this.modeData.remarks;
        this.formValidate.parentId = this.modeData.id;
        this.formValidate.regionKeyword = this.modeData.regionKeyword != ''?this.modeData.regionKeyword.split("|"):[];
        if (this.modeData.regionKeyword != ''){
          let region =  this.modeData.regionKeyword.split("|");
          for (let i = 0; i < this.regionList.length; i++){
            for (let j = 0; j < region.length; j++){
              if (this.regionList[i].name == region[j]){
                this.regionList[i].disabled = true;
              }
            }
          }
        }
        this.formValidate.landmarkKeyword = this.modeData.landmarkKeyword != ''?this.modeData.landmarkKeyword.split("|"):[];
        if (this.dataList.landmarkKeyword != ''){
          let landmark =  this.modeData.landmarkKeyword.split("|");
          for (let i = 0; i < this.landmarkList.length; i++){
            for (let j = 0; j < landmark.length; j++){
              if (this.landmarkList[i].name == landmark[j]){
                this.landmarkList[i].disabled = true;
              }
            }
          }
        }
        let houseInfo = this.modeData.houseInfo.split("|");
        this.formValidate.measure = houseInfo[0];
        this.formValidate.area = houseInfo[1];
        this.formValidate.furniture = houseInfo[2];
        this.formValidate.parkingSpace = houseInfo[3];
        this.formValidate.parkingSpaceA = houseInfo[4];
        await this.getHouseApplyNo(this.formValidate.city);
        for (let i = 0; i < this.formValidate.projectList.length; i++){
          this.formValidate.projectList[i].value = false;
          this.formValidate.projectList[i].top = false;
        }
      }
    }
  }
</script>

<style scoped>
  @import "../../assets/css/detaileds.css";/* 列表样式 */
</style>





// WEBPACK FOOTER //
// src/components/Menu/HousingManagementOperationSchool.vue